import Ajax from 'global/od/Ajax';

const orderHistoryRequestAndDisplayModalModel = requestObj =>
	Ajax({
		dataType: 'html',
		method: 'GET',
		...requestObj,
	});

export default orderHistoryRequestAndDisplayModalModel;
